module.exports = __webpack_public_path__ + "img/ambpoker_logo.426740ad.png";